exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datepicker[data-v-f2985638] {\n  border-bottom: 1px solid #555;\n  width: 200px;\n  font-size: 1.1rem;\n}\n.datepicker-label[data-v-f2985638] {\n  font-size: 1rem;\n  color: #555;\n}\n.alert[data-v-f2985638] {\n  color: #e3342f;\n  font-size: 1rem;\n}\n.payment-radio .v-messages .theme--light[data-v-f2985638] {\n  margin-bottom: 20px;\n}", ""]);

// exports
